@if (checklist.fileTypes?.length > 0) {
  <div class="d-flex align-items-center gap-2 border p-2">
    <span>Files reviewed:</span>
    @for (fileType of checklist.fileTypes; track fileType) {
      <span class="badge fw-normal bg-secondary p-2">{{ fileType }}</span>
    }
  </div>
}

@for (section of checklist.sections; track section.key) {
  <table class="table table-bordered checklist mb-3">
    <thead class="table-dark">
      <tr>
        <th>{{ section.label }}</th>
        <th class="text-center outcome-column">Outcome</th>
      </tr>
    </thead>
    <tbody>
      @for (item of section.items; track item.key) {
        <tr>
          <td class="border-end-0">
            <div>{{ item.label }}</div>
          </td>
          <td class="text-end border-start-0">
            @if (item.kind === 'status' || item.value === null) {
              <span class="badge fw-normal outcome" [ngClass]="statusBadgeClass(item)">
                @if (statusIcon(item)) {
                  <mat-icon>{{ statusIcon(item) }}</mat-icon>
                }
                {{ statusLabel(item) }}
              </span>
            } @else {
              {{ valueLabel(item) }}
            }
            @if (item.detail) {
              <div class="detail">{{ item.detail }}</div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
